import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractComponent } from "@components";
import { ActionResultList, CompetitorResults, EventItem, EventItemType, Lookups, Message, Race, UserDetail } from "@model";
import { EventService } from '@services';
import { EVENT_DETAILS } from 'src/app/app-routing.module';

@Component({
  selector: 'app-user-profile-dashboard-tab',
  templateUrl: './user-profile-dashboard-tab.component.html',
  styleUrls: ['./user-profile-dashboard-tab.component.scss']
})
export class UserProfileDashboardTabComponent extends AbstractComponent implements OnInit{
  @Input() countries: Lookups[] = [];
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() races: Race[] = [];
  @Input() raceUpcomingEvents: Race[] = [];
  @Input({ required: true }) page: number = 1;
  @Input({ required: true }) pageSize: number = 10;
  @Input() isAdmin: boolean = false;
  @Input() favoriteItems: EventItem[] = [];
  @Input() raceResultsMap: Map<Race, CompetitorResults[]> = new Map<Race, CompetitorResults[]>();
  @Input() currentUserDetails: UserDetail | undefined;
  @Input() unreadMessages: Message[] | undefined;
  @Input() users: UserDetail[] = [];
  protected readonly EventItemType = EventItemType;

  constructor(private eventService: EventService, private router: Router, private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.subscribeToFavoritesChange();
  }

  subscribeToFavoritesChange(): void {
    this.subscriptions.push(this.eventService.favoriteEvents.subscribe((value: ActionResultList<EventItem[], number> | null) => {
      if (value && value.result?.length !== undefined) {
        this.favoriteItems = value.result;
      } else {
        this.favoriteItems = [];
      }
    }))
  }

  goToEventDetailsPage(item: EventItem) {
    this.router.navigate([EVENT_DETAILS], {
      relativeTo: this.route,
      queryParams: { eventId: item.id }
    });
  }

  onScroll(event: any): void {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      this.page++;
    }
  }
}
